var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96917 5.66667C8.3445 5.66667 10.4872 6.756 11.8425 8.506C11.2192 5.92667 8.8225 4 5.96917 4C5.6005 4 5.3025 3.702 5.3025 3.33333V2.05133L2.0865 4.834L5.3025 7.642V6.33333C5.3025 5.96467 5.6005 5.66667 5.96917 5.66667ZM12.4805 12C12.1732 12 11.9052 11.79 11.8325 11.4913C11.2392 9.05866 9.15184 7.30133 6.63584 7.03533V7.78266C6.63584 8.25333 6.3565 8.67266 5.90717 8.876C5.41984 9.098 4.85117 9.018 4.45584 8.67333L1.0785 5.724C0.816504 5.49467 0.666504 5.17 0.666504 4.83333C0.666504 4.49667 0.816504 4.172 1.0785 3.94267L4.45584 0.993332C4.85117 0.648665 5.41984 0.568665 5.90717 0.790665C6.3565 0.993999 6.63584 1.41333 6.63584 1.884V2.696C10.3852 3.02467 13.3332 6.1 13.3332 9.83333C13.3332 10.3733 13.2638 10.9307 13.1278 11.4907C13.0558 11.79 12.7885 12 12.4805 12Z",
    fill: "#661C69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.64c7f20de75f3fcad5b1ea7f56814760.svg";
export { ForwardRef as ReactComponent };